import { UPDATE_MENU } from 'src/constants/ActionTypes';
import { ISideMenuState } from 'src/entity/StateEntity';

/**
 * 路由变化与左侧菜单联动
 * @param pathName 路由名称
 */
export function updateMenu(pathName: string): ISideMenuState {
  return {
    type: UPDATE_MENU,
    pathName,
  }
}


// WEBPACK FOOTER //
// ./src/redux/actions/sideLayoutCreator.ts